/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Vue.component('f-select-company', () => import('./select-company'))
  Vue.component('f-select-company-address', () => import('./select-company-address'))
  Vue.component('f-select-company-professional', () => import('./select-company-professional'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/company/index.js